import classNames from 'classnames'
import React from 'react'

interface EmailIconProps {
	size?: 'sm' | 'md' | 'lg'
	color?: 'brand' | 'gray'
}
const EmailIcon: React.FC<EmailIconProps> = ({ size = 'lg', color = 'brand' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className={classNames({
			'w-4 h-4': size === 'sm',
			'w-5 h-5': size === 'md',
			'w-6 h-6': size === 'lg',
		})}
		fill="none"
		viewBox="0 0 14 10"
	>
		<path
			className={classNames({
				'fill-brand-primary-md': color === 'brand',
				'fill-brand-gray-300': color === 'gray',
			})}
			fillRule="evenodd"
			d="M12.424.229L6.647 5.284.87.229c.236-.13.503-.21.792-.21h9.97c.288 0 .555.08.792.21zm.656 8.896c.131-.237.213-.507.213-.799V1.68a1.65 1.65 0 00-.258-.883L8.883 4.429l4.197 4.696zM8.257 4.977L6.92 6.147a.415.415 0 01-.547 0l-1.337-1.17-4.25 4.756c.254.16.552.255.875.255h9.97c.323 0 .622-.095.877-.255l-4.25-4.756zM0 1.68c0-.326.097-.627.259-.883L4.41 4.429.213 9.126a1.642 1.642 0 01-.213-.8V1.68z"
			clipRule="evenodd"
		/>
	</svg>
)

export default EmailIcon
